import z from 'zod';

export const storeBannerItemSchema = z.object({
  id: z.string().default(''),
  pcTitle: z.string().default(''),
  mobileTitle: z.string().default(''),
  titleColor: z.string().default('#0D94FF'),
  subtitle: z.string().default(''),
  imageSrc: z.string().default(''),
  backgroundColor: z.string().default('#ffffff'),
  link: z.string().default('https://zep.us'),
  buttonLabel: z
    .string()
    .transform(label => (label.length > 14 ? truncateLabel(label, 14) : label))
    .default(''),
  buttonColor: z.string().optional().default('#ffffff'),
});

export type StoreBannerItem = z.infer<typeof storeBannerItemSchema>;

function truncateLabel(buttonLabel: string, maxLength: number) {
  if (buttonLabel.length > maxLength) {
    return `${buttonLabel.slice(0, maxLength)}...`;
  }
  return buttonLabel;
}
